import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

// import { ValidationService } from '../../../core/services/validation/validation.service';

// import { Subject } from 'rxjs';
// import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-validation-error',
  templateUrl: './validation-error.component.html',
  styleUrls: ['./validation-error.component.scss'],
})
export class ValidationErrorComponent {
  @Input() control!: AbstractControl;
  @Input() field!: string;
  @Input() errorMsg: string = '';

  errorMsgKey: string = '';
  errorMsgParams: Record<string, any> | undefined;

  // private destroy$: Subject<void>;

  // constructor(private validationService: ValidationService) {
  //   this.destroy$ = new Subject<void>();
  // }

  // ngOnInit(): void {
  //   // this.setEventListeners();
  // }

  // ngOnDestroy(): void {
  //   this.destroy$.next();
  //   this.destroy$.complete();
  // }

  // private getErrorMsg(): [string, Record<string, any> | undefined] | null {
  //   const errors = this.control.errors;

  //   for (const errorName in errors) {
  //     if (errors.hasOwnProperty(errorName)) {
  //       return this.validationService.getMessage(errorName, errors[errorName], this.field);
  //     }
  //   }

  //   return null;
  // }

  // private setEventListeners(): void {
  //   this.control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
  //     const errorMsg = this.getErrorMsg();

  //     if (errorMsg != null) {
  //       [this.errorMsgKey, this.errorMsgParams] = errorMsg;
  //     }
  //   });
  // }
}
